import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormattedFinance } from '../../../../../../../helpers/getFormattedFinance'
import { ITranslationsProps, ITurnoverLargeFormatProps } from '../../models/turnoverProps'

import styles from './TurnoverReadMode.module.scss'

export const TurnoverLargeFormatReadMode: FC<
  ITranslationsProps & Omit<ITurnoverLargeFormatProps, 'isLargeFormatMode'>
> = ({ turnover, turnoverLabelKey = '' }) => {
  const formattedTurnoverValue = useMemo(() => {
    if (turnover === null) {
      return '-'
    }

    return getFormattedFinance(turnover, {
      withCurrencySign: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [turnover])

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedTurnoverValue}</div>
        <div className={styles.label}>
          <Translation text={turnoverLabelKey} span />
        </div>
      </div>
    </div>
  )
}
